/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Logger, green } from "cms/utils/log/logger";
import { generateGuid } from "utils/empty-exists";
// import { CreateEntityDto } from "data/dto/entity/create-entity.dto";
// import { UpdateEntityDto } from "data/dto/entity/update-entity.dto";
// import { removeAuditDates } from "data/dto/model/transformers/remove-audit-dates";
// import Config from "data/config";

export const createEntity = createAsyncThunk(
    "entity/create",
    
    /**
     * @param {object} arg
     * @param {string} arg.token
     * @param {string} arg.entity
     * @param thunkAPI
     */
    async function (arg, thunkAPI) {
        const token = arg?.token;
        const entity = arg?.entity;
        
        // const state = thunkAPI.getState();
        // const model = state?.model?.current;
        // const payload = CreateEntityDto(model?.title, description);
        
        const response = await SimpliCityAdminSDK.entity.create(token, entity);
        
        return response;
    }
);

export const fetchEntity = createAsyncThunk(
    "entity/fetch",
    
    /**
     * @param {object} arg
     * @param {string} arg.token
     * @param {string} arg.id
     * @param thunkAPI
     */
    async function (arg, thunkAPI) {
        const token = arg?.token;
        const guid = arg?.guid;
        const dispatch = thunkAPI?.dispatch;
        const entity = await SimpliCityAdminSDK.entity.findOne(token, guid);
        // also initialize composer field state
        // dispatch({ type: "composer/initFieldState", payload: entity });
        return entity;
    }
);

export const saveEntity = createAsyncThunk(
    "entity/save",

    /**
     * @param {object} arg
     * @param {string} arg.token
     * @param {string} arg.entity
     * @param thunkAPI
     */
    async function (arg, thunkAPI) {
        const token = arg?.token;
        const entity = arg?.entity;
        const dispatch = thunkAPI?.dispatch;
        let response;
        const guid = entity?.guid;
        if (!guid) {
            const guid = generateGuid();
            const key = entity?.key ?? guid;
            const data = { ...entity, guid, key };
            Logger.info(`create entity ${guid}`);
            Logger.info(data);
            response = await SimpliCityAdminSDK.entity.create(token, data);
            console.info(response);
            // dispatch({ type: "entity/initFieldState", payload: response })
        } else {
            const data = { ...entity };
            const guid = entity?.guid;
            Logger.info(`update entity ${guid}`);
            Logger.info(data);
            response = await SimpliCityAdminSDK.entity.update(token, guid, data);
            console.info(response);
            // dispatch({ type: "entity/initFieldState", payload: response })
        }
        return response;
    }
);
